<template>
  <div>
    <div v-show="itens.length" class="text-right mb-3">
      <button class="btn btn-outline-dark" @click="$emit('limpar')">
        <i class="fa fa-check mr-1"></i> Limpar Ocorrências
      </button>
    </div>
    <notificacao-lista :itens="itens"/>
  </div>
</template>

<script>
import NotificacaoLista from './NotificacaoLista';

export default {
  name: 'Ocorrencias',
  components: { NotificacaoLista },
  props: {
    itens: { type: Array, default: () => [] }
  }
};
</script>
